import App from '../app/App'
import Query from '../app/Query'

export class MessagesResource {
  NOTIFICATION_CHANNEL_TEXT_ID = 'push_notification'

  constructor() {
    this.$app = App.instance
    this.$api = this.$app.$api
    this.$resource = this.$app.$resource
  }

  async getCommunicationChannels() {
    const {communication_channels = []} = await this.$resource('communication-channels', {
      action: 'carecloud_api',
      route: 'communication-channels'
    })

    return communication_channels
  }

  async getPushNotificationChannelID() {
    return (await this.getCommunicationChannels()).find((item) => (item.text_id === this.NOTIFICATION_CHANNEL_TEXT_ID))?.communication_channel_id
  }

  async getNotifications(limit = 10, offset = 0) {
    const push_notification_id  = await this.getPushNotificationChannelID()

    let query = (new Query('messages'))
      .add('communication_channel_id', push_notification_id)
      .add('sort_field', 'send_time')
      .add('sort_direction', 'DESC')
      .add('count', limit)
      .add('offset', offset)

    const {messages, total_items} = await this.$api({
      action: 'carecloud_api',
      route: query.route
    })

    let notificationsPromises = []

    for (const item of messages) {
      const res = this.getNotification(item)
      notificationsPromises.push(res)
    }

    return {
      notifications: await Promise.all(notificationsPromises),
      total_items
    }
  }

  async getNotification(item) {
    let query = (new Query(`messages/${item.message_id}/detail`))

    const res = await this.$resource(`messages/${item.message_id}/detail`, {
      action: 'carecloud_api',
      route: query.route
    })

    return {
      title: item.title,
      html_body: res.html_body,
      send_time: item.send_time,
      click_action: item?.message_data.find((item) => item.parameter_name === "__notification_click_action")?.value || null,
      button_text: item?.message_data.find((item) => item.parameter_name === "__notification_button_text")?.value || null,
      button_link: item?.message_data.find((item) => item.parameter_name === "__notification_button_link")?.value || null
    }
  }
}
